<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title>{{ $t("applicationCycles.title") }}</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-select :items="applicationTypes" item-text="name" item-value="id" v-model="model.applicationType"
            :label="$t('application.type')" />
          <FCCDateTime :source="this.model" propertyName="startTime" :label="$t('applicationCycles.startTime')" :required="true" />
          <FCCDateTime :source="this.model" propertyName="endTime" :label="$t('applicationCycles.endTime')" :required="true" />
          <v-text-field v-model="model.amount" :label="$t('applicationCycles.amount')" />
          <v-checkbox v-model="model.paymentByTransfer" :label="$t('applicationCycles.paymentByTransfer')" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="this.save" color="success">
          {{ $t("ctrl.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog
  } from 'vuetify/lib'
  import FCCDateTime from '../widgets/FCCDateTime'
  import fccapi from '../fccapi.js'

  export default {
    name: 'ApplicationCycle',
    data: () => ({
      dialog: false,
      model: {}
    }),
    computed: {
      applicationTypes: function () {
        return [this.$t("application.individual"), this.$t("application.tandem"), this.$t("application.relay")]
          .map((e, i)=>{return {id: i, name: e}})
      },
      rules: function() {
        return {
          required: value =>  !!value || this.$t('registration.required')
        }
      }
    },
    props: {
      source: String
    },
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      VAlert,
      VDialog,
      FCCDateTime
    },
    methods: {
      show: function(obj){
        this.model = JSON.parse(JSON.stringify(obj));
        this.dialog = true;
      },
      save: function(){
        if(this.model.id != undefined){
          console.log("save "+this.model.id)
          fccapi.post(`application-cycles/${this.model.id}`, this.model).then(d => {
            this.$store.dispatch('loadBaseData').then(e => {
              console.log("Base data loaded")
              this.dialog = false;
            }).catch(() => {
              console.log("Couldn't load base data")
            })
          }).catch(e => {
            console.log(e)
          })
        }else{
          this.model.CompetitionId = this.$store.getters.competitionId
          fccapi.post(`application-cycles`, this.model).then(d => {
            this.$store.dispatch('loadBaseData').then(e => {
              console.log("Base data loaded")
              this.dialog = false;
            }).catch(() => {
              console.log("Couldn't load base data")
            })
          }).catch(e => {
            console.log(e)
          })
        }
      }
    },
    mounted: function(){
      
    }
  }
</script>